export const playSound = (url) => {
    let audio = document.createElement('audio')
    audio.setAttribute('src', url)
    audio.setAttribute('allow', 'autoplay')

    audio.play()
}

